<template>
    <div class="setting-wrapper">
        <div class="setting items-start">
            <h4 class="lg:w-1/5">{{ title }}</h4>
            <slot>
                <div class="font-bold text-sm text-neutral-darker lg:w-1/5">
                    {{ setting }}

                    <span v-if="price" class="font-regular text-neutral-dark md:block">
                        {{ price }}
                    </span>
                </div>
                <div v-if="description" class="ml-auto text-sm text-neutral-dark lg:w-3/5">
                    <!-- eslint-disable vue/no-v-html -->
                    <div v-html="description" />
                </div>
            </slot>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: {
                required: true,
                type: String,
            },
            setting: {
                type: String,
                default: '',
            },
            description: {
                required: false,
                type: String,
                default: null,
            },
            price: {
                required: false,
                type: String,
                default: null,
            },
        },
    };
</script>